(ns hai.entity.kebab
  "Shared ⋮ actions menu for entity cards — notes and tasks alike: ordinary
   actions plus an optional destructive Delete that swaps the menu to an inline
   confirm before firing."
  (:require
   [hai.entity.sections :as sections]
   [hai.ui.components :as c]
   [hai.ui.components.dropdown-menu :as dropdown-menu]
   [hai.ui.icons :as icons]
   [hai.ui.tokens :as t]
   [lambdaisland.ornament :as o]
   [reagent.core :as r]))

(def ^:private trash-icon (icons/mui-icon :outlined :delete))

(o/defstyled confirm-title :div
  {:font-size "12.5px" :font-weight "600" :color t/--note-kraft :padding "8px 10px 4px"})

(o/defstyled confirm-row :div
  {:display "flex" :gap "8px" :padding "0 8px 6px"})

(o/defstyled confirm-cancel :button
  {:flex "1" :border "1px solid rgba(50,64,37,0.25)" :border-radius "7px"
   :background "transparent" :color t/--note-kraft :font-family "inherit"
   :font-weight "600" :font-size "12.5px" :padding "6px 10px" :cursor "pointer"})

(o/defstyled confirm-delete :button
  {:flex "1" :border "none" :border-radius "7px"
   :background t/--card-error :color "white" :font-family "inherit"
   :font-weight "600" :font-size "12.5px" :padding "6px 10px" :cursor "pointer"}
  [:&:hover {:background "#7D2020"}])

(defn menu
  "`actions` is a vector of `[caption on-select icon]` — the icon optional. When `on-delete` is given,
   a destructive Delete item is appended that swaps the menu to an inline confirm
   (`confirm-prompt` / `delete-label`) before firing. `aria-label` names the
   trigger for the entity the menu belongs to."
  [{:keys [actions on-delete delete-label confirm-prompt aria-label]
    :or {aria-label "Actions"}}]
  (r/with-let [!open?    (r/atom false)
               !confirm? (r/atom false)
               close!    (fn [] (reset! !confirm? false) (reset! !open? false))]
    [sections/kebab-wrap
     [c/DropdownMenuRoot
      {:modal false
       :open @!open?
       :onOpenChange (fn [open?]
                       (reset! !open? open?)
                       (when-not open? (reset! !confirm? false)))}
      [c/DropdownMenuTrigger
       [:button {:type "button" :aria-label aria-label}
        [icons/filled-more_vert]]]
      ;; Don't return focus to the trigger on close — an "Edit" action moves focus
      ;; into the note's textarea, and Radix's default close-refocus would steal it.
      [c/DropdownMenuContent {:align "end"
                              :onCloseAutoFocus (fn [^js e] (.preventDefault e))}
       (if @!confirm?
         [:<>
          [confirm-title confirm-prompt]
          [confirm-row
           [confirm-cancel {:type "button" :on-click close!} "Cancel"]
           [confirm-delete {:type "button" :on-click (fn [] (close!) (on-delete))} "Delete"]]]
         (into [:<>]
               (cond-> (mapv (fn [[caption on-select icon]]
                               ^{:key caption}
                               [c/DropdownMenuItem {:onSelect on-select}
                                [dropdown-menu/menu-item-content icon caption]])
                             actions)
                 on-delete
                 (conj ^{:key "delete"}
                  [c/DropdownMenuItem
                   {:color "red"
                    :onSelect (fn [e] (.preventDefault e) (reset! !confirm? true))}
                   [dropdown-menu/menu-item-content trash-icon (or delete-label "Delete")]]))))]]]))
